import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function AddonProduct(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.77 1a2.14 2.14 0 012.139 2.137v13.746a2.14 2.14 0 01-2.138 2.138h-1.052v1.833c0 1.21-.984 2.195-2.195 2.195H3.196A2.197 2.197 0 011 20.854V6.525c0-1.21.984-2.195 2.195-2.195h1.69l.002-1.193A2.14 2.14 0 017.026 1H20.77zM4.888 6.348l-1.691.001a.176.176 0 00-.176.176v14.329c0 .097.078.175.176.175h14.328a.175.175 0 00.176-.175v-1.833H7.026a2.14 2.14 0 01-2.138-2.138L4.887 6.348zM20.77 3H7.026a.139.139 0 00-.138.137v13.746a.14.14 0 00.138.138H20.77a.139.139 0 00.138-.138V3.137A.138.138 0 0020.77 3zm-6.872 2.17a1 1 0 011 1v2.84h2.84a1 1 0 010 2H14.9v2.841a1 1 0 01-2 0v-2.84h-2.841a1 1 0 010-2h2.84V6.168a1 1 0 011-1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoAddonProduct = React.memo(AddonProduct);
export default MemoAddonProduct;